import { takeEvery, fork, put, all, call } from "redux-saga/effects"

import {
    GET_OPEN_JOBS
} from './actionTypes';
import {
    getOpenJobsSuccess, getOpenJobsFailed
} from './actions'


import { getCall } from "../../../../../helpers/fakebackend_helper"

//restapi end point
import * as constClass from "../../../../../common/constant/constantURL"

function* getOpenJobsLocal({ payload: { queryParameters } }) {
    try {
        let url = constClass.REST_API_GET_UNMAPPED_JOBS;
        let x = 1;
        
        Object.entries(queryParameters).forEach(entry => {
            const [key, value] = entry;
            if (x == 1) {
                url = url + "?" + key + "=" + encodeURI(value);
            } else {
                url = url + "&" + key + "=" + encodeURI(value);
            }
            x++;
        })
        var responsJSON = yield call(getCall, url);
        yield put(getOpenJobsSuccess(responsJSON))
    }
    catch (error) {
        console.log(error)
        yield put(getOpenJobsFailed(error))
    }
}


export function* watchOpenJobs1() {
    yield takeEvery(GET_OPEN_JOBS, getOpenJobsLocal)
}
function* openJobsSaga() {
    yield all([fork(watchOpenJobs1)])
}

export default openJobsSaga